
const NotFound = () => {
	return (
		<div className="text-center w-100" style={{ height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '20px'}}>
			!! 일치하는 이벤트가 없습니다 !!
		</div>
	)

}

export default NotFound;
